// Open external links in a new window.
// Delegated from the document so there is no upfront pass over every link on
// load, and links added later (quick view, AJAX filters, cart drawer) are
// covered without rebinding.
document.addEventListener("click", function (evt) {
  var target = evt.target;

  if (!target || typeof target.closest !== "function") {
    return;
  }

  var link = target.closest("a[href]");

  if (!link || link.target) {
    return;
  }

  // Leave mailto:, tel: and other non-web schemes alone.
  if (link.protocol !== "http:" && link.protocol !== "https:") {
    return;
  }

  if (link.hostname === window.location.hostname) {
    return;
  }

  link.target = "_blank";
  link.rel = "noreferrer noopener";
});
